var map = {
	"./index.js": "6ean",
	"./notifications.js": "Toit"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nVh8";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/notifications nonrecursive \.js$
// module id = nVh8
// module chunks = 11